module.exports = require("next/app");


//////////////////
// WEBPACK FOOTER
// external "next/app"
// module id = next/app
// module chunks = 2